export const handleUpload = (fileInputRef:any) => {
    if (fileInputRef.current) fileInputRef.current.click();
  };    